module.exports = __webpack_public_path__ + "img/jurasov.509ffc1a.jpg";